import React, { useEffect, useMemo } from 'react';
import LeasingIncomeSchemaGeneralDataContainer from './LeasingIncomeSchemaGeneralDataContainer';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import FlexBox from 'components/common/FlexBox';
import { isIncomeSchemaEditableVar, negotiationLimitsInAbsoluteValuesVar } from '../variables';
import LeasingIncomeSchemaStateContainer from './LeasingIncomeSchemaStateContainer';
import LeasingIncomeSchemaDetailsContainer from './LeasingIncomeSchemaDetailsContainer';

const LeasingIncomeSchemaContainer = () => {
  const match = useRouteMatch();

  const id = useMemo(() => match.params.id && getInt(match.params.id), [match]);

  useEffect(
    () => () => {
      isIncomeSchemaEditableVar(null);
      negotiationLimitsInAbsoluteValuesVar(null);
    },
    []
  );

  return (
    <FlexBox direction='column'>
      <LeasingIncomeSchemaGeneralDataContainer id={id} />
      {id && <LeasingIncomeSchemaStateContainer id={id} />}
      {id && <LeasingIncomeSchemaDetailsContainer id={id} />}
    </FlexBox>
  );
};

export default LeasingIncomeSchemaContainer;
